import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import localeData, { LOAN } from '../../js/localizations/locale-data';
import { useOptions } from '../../context/options';
import { region } from '../../js/localizations/current-locale';

const useCalculateInterestRate = () => {
  const { optionVariables } = useOptions();
  const values = useSelector((state) => state.form.application.values)
    || localeData.MERGE_LOAN_FORM_DEFAULT_VALUES;
  const { totalAmount } = values;
  const formState = useSelector((state) => state.form.application);

  const [ranges, setRanges] = useState([]);
  const [interest, setInterest] = useState(null);

  const disclaimer = optionVariables?.dynamicFormDisclaimer;
  const isNO = region === 'NO';
  const mergeNoCheck = values.merge && isNO;

  const EXAMPLE_INTEREST = 0.058;

  useEffect(() => {
    if (mergeNoCheck) {
      const sortedRanges = disclaimer?.consolidationInterestRanges
        ?.sort((a, b) => a.consolidationUpTo - b.consolidationUpTo);
      setRanges(sortedRanges || []);
    } else {
      const sortedRanges = disclaimer?.interestRanges
        ?.sort((a, b) => a.upTo - b.upTo);
      setRanges(sortedRanges || []);
    }
  }, [disclaimer, mergeNoCheck]);

  useEffect(() => {
    if (ranges?.length > 0) {
      const checkTotalAmount = (totalAmount > LOAN.UP_TO)
        ? LOAN.UP_TO
        : totalAmount;
      const interestRate = mergeNoCheck
        ? ranges.find((range) => range.consolidationUpTo >= checkTotalAmount)
        : ranges.find((range) => range.upTo >= checkTotalAmount);
      setInterest(interestRate || null);
    }
  }, [ranges, totalAmount, formState, mergeNoCheck]);

  return interest
    ? (mergeNoCheck ? interest.consolidationInterestRate : interest.interestRate) / 100
    : EXAMPLE_INTEREST;
};

export default useCalculateInterestRate;
